/**
 * SecureServiceComponent Statefull Component
 */
import { HowItWorks } from "components/WaitingView/HowItWorksComponent";
import { OtpTypeEnum } from "components/WaitingView/OtpTypeEnum";
// istanbul ignore next
import {
  hideModal,
  hideNesterErrorModal,
  notifyUpdate,
  resetCardState,
  updateOtpValue,
} from "containers/Card/store/Actions";

import { CardAction } from "containers/Card/store/CardAction";
import { CardState } from "containers/Card/store/CardState";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledPopover,
} from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CajitaStore } from "root/store/CajitaStore";

/**
 * SecureServiceComponent State interface
 */
interface IModalState {
  currentOtp: string;
}

/**
 * SecureServiceComponent Component
 */
// istanbul ignore next
class OtpComponent extends React.Component<CardState, IModalState> {
  public inputNode1: React.RefObject<HTMLInputElement>;
  public inputNode2: React.RefObject<HTMLInputElement>;
  public inputNode3: React.RefObject<HTMLInputElement>;
  public currentInput: string;
  private digits: string[] = ["", "", ""];

  private inputDinersNode1: React.RefObject<HTMLInputElement>;
  private inputDinersNode2: React.RefObject<HTMLInputElement>;
  private inputDinersNode3: React.RefObject<HTMLInputElement>;
  private inputDinersNode4: React.RefObject<HTMLInputElement>;
  private inputDinersNode5: React.RefObject<HTMLInputElement>;
  private inputDinersNode6: React.RefObject<HTMLInputElement>;
  private checkboxDinersNode: React.RefObject<HTMLInputElement>;

  /* tslint:disable:all */
  constructor(props: CardState) {
    super(props);
    this.state = {
      currentOtp: "",
    };

    this.initializeInputs();

    this.updateFirstDigit = this.updateFirstDigit.bind(this);
    this.updateSecondDigit = this.updateSecondDigit.bind(this);
    this.updateThirdDigit = this.updateThirdDigit.bind(this);

    this.updateInlineInput = this.updateInlineInput.bind(this);
    this.updateThirdInput = this.updateThirdInput.bind(this);
    this.updateFirstInput = this.updateFirstInput.bind(this);
    this.isKeyAllowed = this.isKeyAllowed.bind(this);

    this.firstInputKeyDownHandler = this.firstInputKeyDownHandler.bind(this);
    this.secondInputKeyDownHandler = this.secondInputKeyDownHandler.bind(this);
    this.thirdInputKeyDownHandler = this.thirdInputKeyDownHandler.bind(this);

    this.firstDinersInputKeyDownHandler = this.firstDinersInputKeyDownHandler.bind(
      this
    );
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
    this.thirdDinersInputKeyDownHandler = this.thirdDinersInputKeyDownHandler.bind(
      this
    );

    this.isConfirmEnabled = this.isConfirmEnabled.bind(this);
    this.updateOtp = this.updateOtp.bind(this);
    this._getPopperButton = this._getPopperButton.bind(this);
    this._getOtpInputs = this._getOtpInputs.bind(this);
    this._getKushkiInputs = this._getKushkiInputs.bind(this);
    this._getDinersInputs = this._getDinersInputs.bind(this);
    this.focusFistInput = this.focusFistInput.bind(this);
    this.clearInputs = this.clearInputs.bind(this);

    this.submitOtpValue = this.submitOtpValue.bind(this);

    this.getHelpLink = this.getHelpLink.bind(this);
  }

  private initializeInputs() {
    this.currentInput = "";
    this.inputNode1 = React.createRef<HTMLInputElement>();
    this.inputNode2 = React.createRef<HTMLInputElement>();
    this.inputNode3 = React.createRef<HTMLInputElement>();

    this.inputDinersNode1 = React.createRef<HTMLInputElement>();
    this.inputDinersNode2 = React.createRef<HTMLInputElement>();
    this.inputDinersNode3 = React.createRef<HTMLInputElement>();
    this.inputDinersNode4 = React.createRef<HTMLInputElement>();
    this.inputDinersNode5 = React.createRef<HTMLInputElement>();
    this.inputDinersNode6 = React.createRef<HTMLInputElement>();

    this.checkboxDinersNode = React.createRef<HTMLInputElement>();
  }

  public componentDidUpdate(): void {
    if (this.props.showOtpError === true) {
      setTimeout(() => this.props.hideNesterErrorModal(), 5000); // 5 seconds
      this.clearInputs();
    }

    this.focusFistInput();
  }

  /* tslint:disable: max-func-body-length */
  public render(): React.ReactNode {
    const otp_type: string | undefined = this.props.otpType;

    const is_disabled: boolean =
      this.props.nestedErrorCode === "OTP200" ||
      this.props.nestedErrorCode === "OTP300";
    const nested_error: string =
      this.props.nestedOtpMessage !== undefined
        ? `${this.props.nestedOtpMessage}`
        : "Por favor ingrese nuevamente";

    // istanbul ignore next
    return (
      <>
        {this.props.otpState === false && (
          <div>
            <div className="error-message">
              <Translate id={"invalidOtpMessage"} />
            </div>
          </div>
        )}
        <Form>
          <FormGroup>
            <Container fluid>
              <Row>
                <label className={"otpMessageTitle"}>
                  <Translate id={"otpKushkiTitle"} />
                </label>
                <Label for="code" className={"otpTextBox"}>
                  <Translate id={"messageKushki"} />
                </Label>
                {this._getOtpInputs(otp_type, is_disabled)}
              </Row>
            </Container>
            <div className="button margin-button">
              <Button
                color={"primary"}
                disabled={!this.isConfirmEnabled() || is_disabled}
                onClick={(): void => this.submitOtpValue()}
                className={`confirm-button ${!this.isConfirmEnabled() &&
                  "disabled"}`}
              >
                <Translate id={"otpButtonText"} />
              </Button>
            </div>
          </FormGroup>
        </Form>
      </>
    );
  }

  private getHelpLink(otpType: string | undefined): object | null {
    return otpType === OtpTypeEnum.DINERS ? null : (
      <div className={"helpLink"}>
        <a id={"helpfulLink"} className={"linkColor"}>
          <Translate id={"howItWorks"} />
        </a>
        <UncontrolledPopover
          trigger="legacy"
          placement="bottom"
          target="helpfulLink"
        >
          <HowItWorks />
        </UncontrolledPopover>
      </div>
    );
  }

  private focusFistInput(): void {
    // @ts-ignore
    if (
      this.state.currentOtp === "" &&
      this.inputDinersNode1 !== null &&
      this.inputDinersNode1.current !== null &&
      this.inputDinersNode1.current.value !== undefined
    )
      // @ts-ignore
      this.inputDinersNode1.focus();
    // @ts-ignore
    if (
      this.state.currentOtp === "" &&
      this.inputNode1 !== null &&
      this.inputDinersNode1.current !== null &&
      this.inputDinersNode1.current.value !== undefined
    )
      // @ts-ignore
      this.inputNode1.focus();
  }

  private clearInputs(): void {
    const value_key: string = "value";
    if (this.state.currentOtp !== "") this.setState({ currentOtp: "" });

    if (
      this.inputDinersNode1 !== null &&
      this.inputDinersNode1[value_key] !== undefined
    ) {
      this.inputDinersNode1[value_key] = "";
      this.inputDinersNode2[value_key] = "";
      this.inputDinersNode3[value_key] = "";
      this.inputDinersNode4[value_key] = "";
      this.inputDinersNode5[value_key] = "";
      this.inputDinersNode6[value_key] = "";
    }
    if (this.inputNode1 !== null && this.inputNode1[value_key] !== undefined) {
      this.inputNode1[value_key] = "";
      this.inputNode2[value_key] = "";
      this.inputNode3[value_key] = "";
    }
  }

  private _getOtpInputs(opt_type: string | undefined, is_disabled: boolean) {
    switch (opt_type) {
      case OtpTypeEnum.KUSHKI:
        return this._getKushkiInputs(is_disabled);
      case OtpTypeEnum.DINERS:
        return this._getDinersInputs(is_disabled);
      default:
        return this._getKushkiInputs(is_disabled);
    }
  }

  private _getDinersInputs(is_disabled: boolean) {
    return (
      <div>
        <Row className={"dinersInputContainer"}>
          <div className={"dinersOtpInput"}>
            <Input
              type="number"
              innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                this.inputDinersNode1 = input;
              }}
              className={"otpInput"}
              disabled={is_disabled}
              onKeyDown={(e: React.KeyboardEvent): void => {
                this.firstDinersInputKeyDownHandler(e);
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                this.updateFirstInput(
                  e.target.value,
                  this.inputDinersNode1,
                  this.inputDinersNode2
                );
              }}
            />
          </div>
          <div className={"dinersOtpInput"}>
            <Input
              type="number"
              innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                this.inputDinersNode2 = input;
              }}
              className={"otpInput"}
              disabled={is_disabled}
              onKeyDown={(e: React.KeyboardEvent): void => {
                this.onKeyDownHandler(
                  e,
                  this.inputDinersNode2,
                  this.inputDinersNode3,
                  this.inputDinersNode1
                );
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                this.updateInlineInput(
                  e.target.value,
                  this.inputDinersNode3,
                  1
                );
              }}
            />
          </div>
          <div className={"dinersOtpInput"}>
            <Input
              type="number"
              innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                this.inputDinersNode3 = input;
              }}
              className={"otpInput"}
              disabled={is_disabled}
              onKeyDown={(e: React.KeyboardEvent): void => {
                this.onKeyDownHandler(
                  e,
                  this.inputDinersNode3,
                  this.inputDinersNode4,
                  this.inputDinersNode2
                );
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                this.updateInlineInput(
                  e.target.value,
                  this.inputDinersNode4,
                  2
                );
              }}
            />
          </div>
          <div className={"dinersOtpInput"}>
            <Input
              type="number"
              innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                this.inputDinersNode4 = input;
              }}
              className={"otpInput"}
              disabled={is_disabled}
              onKeyDown={(e: React.KeyboardEvent): void => {
                this.onKeyDownHandler(
                  e,
                  this.inputDinersNode4,
                  this.inputDinersNode5,
                  this.inputDinersNode3
                );
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                this.updateInlineInput(
                  e.target.value,
                  this.inputDinersNode5,
                  3
                );
              }}
            />
          </div>
          <div className={"dinersOtpInput"}>
            <Input
              type="number"
              innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                this.inputDinersNode5 = input;
              }}
              className={"otpInput"}
              disabled={is_disabled}
              onKeyDown={(e: React.KeyboardEvent): void => {
                this.onKeyDownHandler(
                  e,
                  this.inputDinersNode5,
                  this.inputDinersNode6,
                  this.inputDinersNode4
                );
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                this.updateInlineInput(
                  e.target.value,
                  this.inputDinersNode6,
                  4
                );
              }}
            />
          </div>
          <div className={"dinersOtpInput"}>
            <Input
              type="number"
              innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                this.inputDinersNode6 = input;
              }}
              className={"otpInput"}
              disabled={is_disabled}
              onKeyDown={(e: React.KeyboardEvent): void => {
                this.thirdDinersInputKeyDownHandler(
                  e,
                  this.inputDinersNode6,
                  this.inputDinersNode5
                );
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                // @ts-ignore
                this.inputDinersNode6.value = e.target.value;

                this.digits[5] =
                  e.target.value === undefined ? "" : e.target.value;
                this.updateOtp();
              }}
            />
          </div>
        </Row>
        <Row>
          <div className="top-margin">
            <Label for="code" className={"otpTextBox"}>
              La clave expira en 5 minutos. Si no la recibe por favor
              comuníquese al (02) 2984-400.
            </Label>
            <Label check className={"checkbox-diners-text"}>
              <Input
                type="checkbox"
                className={"checkbox-diners"}
                innerRef={(input: React.RefObject<HTMLInputElement>): void => {
                  this.checkboxDinersNode = input;
                }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  this.updateOtp();
                }}
              />{" "}
              <a
                href={
                  "https://onlineservices.dinersclub.com.ec/Diners/documentos/CLNTECMK00000543.pdf"
                }
                target={"_blank"}
              >
                Acepto términos y condiciones de la validación con clave
                temporal
              </a>
            </Label>
          </div>
        </Row>
      </div>
    );
  }

  private _getKushkiInputs(is_disabled: boolean) {
    return (
      <div className="opt-inputs-section ">
        <Input
          type="number"
          innerRef={(input: React.RefObject<HTMLInputElement>): void => {
            this.inputNode1 = input;
          }}
          className={`otpInput`}
          disabled={is_disabled}
          onKeyDown={(e: React.KeyboardEvent): void => {
            this.firstInputKeyDownHandler(e);
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
            this.updateFirstInput(e.target.value);
          }}
        />

        <Input
          type="number"
          innerRef={(input: React.RefObject<HTMLInputElement>): void => {
            this.inputNode2 = input;
          }}
          className={`otpInput`}
          disabled={is_disabled}
          onKeyDown={(e: React.KeyboardEvent): void => {
            this.onKeyDownHandler(
              e,
              this.inputNode2,
              this.inputNode3,
              this.inputNode1
            );
            this.secondInputKeyDownHandler(e);
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
            this.updateInlineInput(e.target.value, this.inputNode3, 1);
          }}
        />
        <Input
          type="number"
          innerRef={(input: React.RefObject<HTMLInputElement>): void => {
            this.inputNode3 = input;
          }}
          className={`otpInput`}
          disabled={is_disabled}
          onKeyDown={(e: React.KeyboardEvent): void => {
            this.thirdInputKeyDownHandler(e);
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
            this.updateThirdInput(e.target.value);
          }}
        />
      </div>
    );
  }

  private _getPopperButton(): object {
    return (
      <Col xs={{ size: 2 }} className={"colQuestionOtp"}>
        <Button
          className="questionMark questionButton"
          id="PopoverFocus"
          type="button"
        />
        <UncontrolledPopover
          trigger="focus"
          placement="bottom"
          target="PopoverFocus"
        >
          <HowItWorks />
        </UncontrolledPopover>
      </Col>
    );
  }

  private isConfirmEnabled(): boolean {
    const value_key: string = "value";
    const checked_key: string = "checked";

    return (
      (this.inputNode1 !== null &&
        this.inputNode1[value_key] !== undefined &&
        this.inputNode2[value_key] !== undefined &&
        this.inputNode3[value_key] !== undefined &&
        this.inputNode1[value_key] !== "" &&
        this.inputNode2[value_key] !== "" &&
        this.inputNode3[value_key] !== "") ||
      (this.inputDinersNode1 !== null &&
        this.inputDinersNode1[value_key] !== undefined &&
        this.inputDinersNode2[value_key] !== undefined &&
        this.inputDinersNode3[value_key] !== undefined &&
        this.inputDinersNode4[value_key] !== undefined &&
        this.inputDinersNode5[value_key] !== undefined &&
        this.inputDinersNode6[value_key] !== undefined &&
        this.inputDinersNode1[value_key] !== "" &&
        this.inputDinersNode2[value_key] !== "" &&
        this.inputDinersNode3[value_key] !== "" &&
        this.inputDinersNode4[value_key] !== "" &&
        this.inputDinersNode5[value_key] !== "" &&
        this.inputDinersNode6[value_key] !== "" &&
        this.checkboxDinersNode[checked_key] === true)
    );
  }

  private updateOtp(): void {
    const new_otp: string = this.digits.reduce((x, y) => `${x}${y}`);

    this.setState({ currentOtp: new_otp });
  }

  private firstInputKeyDownHandler(e: React.KeyboardEvent): void {
    if (["e", "+", "-", ".", ","].includes(e.key)) {
      e.preventDefault();

      return;
    }
    if (this.isKeyAllowed(e, this.inputNode1)) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode1.value = e.key;
      this.updateFirstInput(e.key);

      return;
    }
    if (e.keyCode === 39) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode2.focus();
    }

    if (e.keyCode === 37) e.preventDefault();
  }

  private secondInputKeyDownHandler(e: React.KeyboardEvent): void {
    if (["e", "+", "-", ".", ","].includes(e.key)) {
      e.preventDefault();

      return;
    }
    // @ts-ignore
    if (this.isKeyAllowed(e, this.inputNode2)) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode2.value = e.key;
      this.updateInlineInput(e.key);

      return;
    }

    if (e.keyCode === 39) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode3.focus();
    } else if (e.keyCode === 37) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode1.focus();
    } else if (e.keyCode === 8) {
      e.preventDefault();
      const value_key: string = "value";

      if (this.inputNode2[value_key] === "")
        // @ts-ignore
        this.inputNode1.focus();
      else this.inputNode2[value_key] = "";
    }
  }

  private thirdInputKeyDownHandler(e: React.KeyboardEvent): void {
    if (["e", "+", "-", ".", ","].includes(e.key)) {
      e.preventDefault();

      return;
    }

    if (this.isKeyAllowed(e, this.inputNode3)) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode3.value = e.key;
      this.updateThirdInput(e.key);

      return;
    }

    if (e.keyCode === 37) {
      e.preventDefault();
      // @ts-ignore
      this.inputNode2.focus();
    } else if (e.keyCode === 8) {
      e.preventDefault();
      const value_key: string = "value";

      if (this.inputNode3[value_key] === "")
        // @ts-ignore
        this.inputNode2.focus();
      else this.inputNode3[value_key] = "";
    }
  }

  private firstDinersInputKeyDownHandler(e: React.KeyboardEvent): void {
    if (["e", "+", "-", ".", ","].includes(e.key)) {
      e.preventDefault();

      return;
    }
    if (this.isKeyAllowed(e, this.inputDinersNode1)) {
      e.preventDefault();
      // @ts-ignore
      this.inputDinersNode1.value = e.key;
      this.updateFirstInput(
        e.key,
        this.inputDinersNode1,
        this.inputDinersNode2
      );

      return;
    }
    if (e.keyCode === 39) {
      e.preventDefault();
      // @ts-ignore
      this.inputDinersNode2.focus();
    }

    if (e.keyCode === 37) e.preventDefault();
  }

  private onKeyDownHandler(
    e: React.KeyboardEvent,
    currentInput: React.RefObject<HTMLInputElement>,
    nextInput: React.RefObject<HTMLInputElement>,
    previousInput: React.RefObject<HTMLInputElement>
  ): void {
    if (["e", "+", "-", ".", ","].includes(e.key)) {
      e.preventDefault();

      return;
    }
    // @ts-ignore
    if (this.isKeyAllowed(e, currentInput)) {
      e.preventDefault();
      // @ts-ignore
      currentInput.value = e.key;
      this.updateInlineInput(e.key, nextInput);

      return;
    }

    if (e.keyCode === 39) {
      e.preventDefault();
      // @ts-ignore
      nextInput.focus();
    } else if (e.keyCode === 37) {
      e.preventDefault();
      // @ts-ignore
      previousInput.focus();
    } else if (e.keyCode === 8) {
      e.preventDefault();
      const value_key: string = "value";

      if (currentInput[value_key] === "")
        // @ts-ignore
        previousInput.focus();
      else currentInput[value_key] = "";
    }
  }

  private thirdDinersInputKeyDownHandler(
    e: React.KeyboardEvent,
    currentInput: React.RefObject<HTMLInputElement>,
    previousInput: React.RefObject<HTMLInputElement>
  ): void {
    if (["e", "+", "-", ".", ","].includes(e.key)) {
      e.preventDefault();

      return;
    }

    if (this.isKeyAllowed(e, currentInput)) {
      e.preventDefault();
      // @ts-ignore
      currentInput.value = e.key;
      this.digits[5] = e.key === undefined ? "" : e.key;
      this.updateOtp();

      return;
    }

    if (e.keyCode === 37) {
      e.preventDefault();
      // @ts-ignore
      previousInput.focus();
    } else if (e.keyCode === 8) {
      e.preventDefault();
      const value_key: string = "value";

      if (currentInput[value_key] === "")
        // @ts-ignore
        previousInput.focus();
      else currentInput[value_key] = "";
    }
  }

  private isKeyAllowed(
    e: React.KeyboardEvent,
    inputNode: React.RefObject<HTMLInputElement>
  ): boolean {
    return (
      e.key.length === 1 &&
      // @ts-ignore
      (String(inputNode.value) + e.key).length > 1 &&
      /^\d+$/.test(e.key)
    );
  }

  private updateFirstInput(
    e: string,
    input1?: React.RefObject<HTMLInputElement>,
    input2?: React.RefObject<HTMLInputElement>
  ): void {
    if (input1 === undefined) {
      if (!["e", "+", "-"].includes(e)) this.updateFirstDigit(e);
      else {
        // @ts-ignore
        this.inputNode1.value = "";
        this.updateFirstDigit("");
      }

      if (e !== "")
        // @ts-ignore
        this.inputNode2.focus();

      return;
    }

    if (!["e", "+", "-"].includes(e)) this.updateFirstDigit(e);
    else {
      // @ts-ignore
      input1.value = "";
      this.updateFirstDigit("");
    }

    if (e !== "")
      // @ts-ignore
      input2.focus();
  }

  private updateInlineInput(
    e: string,
    nextInput?: React.RefObject<HTMLInputElement>,
    updatePosition?: number
  ): void {
    if (updatePosition === undefined) this.updateSecondDigit(e);
    else {
      this.digits[updatePosition] = e === undefined ? "" : e;
      this.updateOtp();
    }
    if (e !== "")
      if (nextInput === undefined)
        // @ts-ignore
        this.inputNode3.focus();
      // @ts-ignore
      else nextInput.focus();
  }

  private updateThirdInput(e: string): void {
    this.updateThirdDigit(e);
  }

  private updateFirstDigit(newValue: string | undefined): void {
    this.digits[0] = newValue === undefined ? "" : newValue;
    this.updateOtp();
  }

  private updateSecondDigit(newValue: string | undefined): void {
    this.digits[1] = newValue === undefined ? "" : newValue;
    this.updateOtp();
  }

  private updateThirdDigit(newValue: string | undefined): void {
    this.digits[2] = newValue === undefined ? "" : newValue;
    this.updateOtp();
  }

  private submitOtpValue(): void {
    let new_otp: string;

    if (this.props.otpType === OtpTypeEnum.DINERS) {
      new_otp = `${this.digits[0]}${this.digits[1]}${this.digits[2]}${
        this.digits[3]
      }${this.digits[4]}${this.digits[5]}`;
    } else {
      new_otp = `${this.digits[0]}${this.digits[1]}${this.digits[2]}`;
    }

    this.props.updateOtpValue(new_otp);
    this.props.notifyUpdate();

    this.clearInputs();
  }
}

// istanbul ignore next
const mapStateToProps: (state: CajitaStore) => CardState = (
  state: CajitaStore
): CardState => ({
  ...state.card,
});

// istanbul ignore next
const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, CardAction>
): object => ({
  updateOtpValue: (payload: string): void => dispatch(updateOtpValue(payload)),
  hideModal: (): void => dispatch(hideModal()),
  hideNesterErrorModal: (): void => dispatch(hideNesterErrorModal()),
  notifyUpdate: (): void => dispatch(notifyUpdate()),
  resetCardState: (): void => dispatch(resetCardState()),
});

const OtpContainer: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(OtpComponent);

export { OtpContainer };



// WEBPACK FOOTER //
// ./src/components/WaitingView/OtpComponent.tsx